module.exports = __webpack_public_path__ + "static/other/diseased_trees_game_3.3b127579.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/diseaseTreesGame/diseased_trees_game_3.json
// module id = 2362
// module chunks = 0